import React, { useEffect, useState } from 'react'
import FlightBanner from './FlightBanner'
import HomeFlight from '../home/HomeFlight'
import { apiData } from '../../../actions';
import { useSelector } from 'react-redux';
import DataLoader from '../../../Utils/DataLoader';
import { Link } from 'react-router-dom';
import Favorite from '../../../assets/images/Favorite-bg2.png'

export default function FlightIndex() {
    const place = useSelector((state) => state.place);
    const localSelectedCity = localStorage.getItem("selectedCity");
    const formattedCity = place?.replace(/\b\w/g, (x) => x.toUpperCase()) || "";

    const [scriptURL, setScriptURL] = useState("");
    const [loading, setLoading] = useState(true);

    const fetchDigInto = async () => {
        setLoading(true);

        const payload = { city: place };
        const apiRes = await apiData.getDigInto(payload);

        if (apiRes?.status >= 200 && apiRes?.status <= 399) {

            // Your response → apiRes.data[0].content
            const content = apiRes?.data?.digInto?.[0]?.content || "";

            // Extract the script src="..."
            const extractedURL = content?.match(/src=["']([^"']+)["']/)?.[1];

            if (extractedURL) {
                setScriptURL(extractedURL.startsWith("//") ? "https:" + extractedURL : extractedURL);
            } else {
                console.error("No script URL found in API content");
            }
        }

        setLoading(false);
    };

    useEffect(() => {
        fetchDigInto();
    }, [place]);

    // Inject script
    useEffect(() => {
        if (!scriptURL) return;

        const container = document.getElementById("digInto");
        if (!container) return;

        container.innerHTML = "";

        const script = document.createElement("script");
        script.src = scriptURL;
        script.async = true;

        container.appendChild(script);
    }, [scriptURL]);

    if (loading) return <DataLoader />;
    return (
        <>
            <FlightBanner />
            <section className="section-equal-padding pb-0 bg-white d-none d-md-block"></section>

            <HomeFlight />
            <section className="section-equal-padding owl-nav-left">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                            <div className="section-top-heading mb-3 mb-md-5 text-center"
                                uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
                                <h2 className="mb-2 text-black">{localSelectedCity && localSelectedCity !== 'undefined'
                                    ? `Dig Into ${formattedCity}`
                                    : 'Dig Into'}
                                </h2>

                                <p>
                                    Stories, tips, and guides
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-12">
                        <div data-aos="zoom-in-right" className="testimonial-section products client-sec comedy family-sec where_say_sec">

                            <div id="digInto"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="section-equal-padding favorite-section uk-scrollspy-inview"
                style={{ backgroundImage: `url(${Favorite})` }}
                uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
                <div className="container d-flex justify-content-center text-center">
                    <div className="favorite-block uk-scrollspy-inview"
                        uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
                        <h2 className="mb-4">Fly Anywhere, Anytime – <br />Find the Perfect Flight for <br />Your Journey</h2>
                        <p>
                            Search, compare, and book flights from hundreds of airlines worldwide. Whether it’s a weekend
                            getaway or a dream vacation, we make finding the best fares simple, fast, and stress-free. Your next
                            adventure is just a few clicks away.
                        </p>
                        <Link to={place ? '/deals/:sub' : '/deals'} className="white-btn mt-3">View Deals</Link>
                    </div>
                </div>
            </section>
        </>
    )
}
